module.exports = "/packs/media/images/icons/healthexpense-6f2672246ac0cafe85a40327a94d8b72.png";